import React from "react"

import SEOHelmet from '../../../../../components/Layout/SEOHelmet'
import FTPServer from "../../../../../components/Products/Software/Videos/video-instarvision-iphone-user"
import Footer from "../../../../../components/Layout/footer"

const seodata = {
  title: 'iOS App InstarVision',
  description: 'Use our InstarVision iOS app to manage your camera from your iPhone or iPad. Or use one of many supported third-party applications.',
  image: '/images/Search/P_SearchThumb_InstarVision_iOS.png'
};

// export default (props) => (

function UserManagement(props) {
  return (
  
    <React.Fragment>
      <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
      <h1 id="introduction" style={{ marginTop: 0 }}>
        InstarVision Benutzerverwaltung
      </h1>
      <FTPServer />
      <br />
      <br />
      <Footer
        previousTitle="InstarVision (iOS)"
        previousLink="/fr/Software/iOS/InstarVision/"
        nextTitle="Recordings"
        nextLink="/fr/Software/iOS/InstarVision/Video/Recordings/" />
    </React.Fragment>
  )
}

export default UserManagement